import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { MIX_DIRECTIONS } from './constants';

/** Compact Asc/Desc direction select. */
export default function DirectionSelect({ value, onChange, label = 'Dir', size = 'small', sx = {} }) {
  return (
    <FormControl size={size} sx={{ minWidth: 72, ...sx }}>
      <InputLabel>{label}</InputLabel>
      <Select value={value} onChange={(e) => onChange(e.target.value)} label={label}>
        {MIX_DIRECTIONS.map((d) => (
          <MenuItem key={d.value} value={d.value}>
            {d.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
